import request from '@/utils/request'

// 微信授权登录
// export function login(params) {
//   return request({
//     url: 'login/wechat',
//     params
//   })
// }

// 手机号登录
export function login(data) {
  return request({
    url: 'login/phone',
    data,
    method: 'post',
  })
}

// 短信验证码
export function sendMsg(data) {
  return request({
    url: 'login/send_msg_code',
    data,
    method: 'post',
  })
}

// 用户信息
export function getUserInfo(params) {
  return request({
    url: 'member/get',
    params
  })
}

// 上传图片
export function upload(data) {
  return request({
    url: 'uploading/addpic',
    method: 'post',
    data
  })
}

// 获取分类
export function getCate(params) {
  return request({
    url: "category/list",
    params
  })
}

// 添加
export function addArticle(data) {
  return request({
    url: "article/add",
    method: 'post',
    data
  })
}

// 个人作品
export function memberList(params) {
  return request({
    url: "member/list",
    params
  })
}

// 首页优秀作品
export function listIndex(params) {
  return request({
    url: "list/index",
    params
  })
}

// 优秀作品
export function listData(params) {
  return request({
    url: "list/data",
    params
  })
}

// 图片详情
export function listDetail(params) {
  return request({
    url: "list/detail",
    params
  })
}

// 用户图片详情
export function memberDetail(params) {
  return request({
    url: "member/detail",
    params
  })
}

// 用户投票
export function voteAdd(params) {
  return request({
    url: "vote/add",
    params
  })
}